<template>
<div class="chapter">
<div class="inner_page">
<div style="margin-left:10%; margin-top:3em">
<p> </p>
<p> </p>
<p class="initial"><a href="#/introduction" id="introduction"><span style="color:#000000">Introduction</span></a></p>
<p class="initial"> </p>
<p class="initial"><a href="#/chapter1" id="chapter1"><span style="color:#C4084A">Cookies</span></a></p>
<p class="initial"> </p>
<p class="initial"><span href="#/chapter2" id="chapter2" title="Link target outside of Sample"><span style="color:#C4084A">Cupcakes</span></span> </p>
<p class="initial"> </p>
<p class="initial"><span href="#/chapter3" id="chapter3" title="Link target outside of Sample"><span style="color:#C4084A">Whoopie Pies </span></span></p>
<p class="initial"> </p>
<p class="initial"><span href="#/chapter4" id="chapter4" title="Link target outside of Sample"><span style="color:#C4084A">Doughnuts </span></span></p>
<p class="initial"> </p>
<p class="initial"><span href="#/chapter5" id="chapter5" title="Link target outside of Sample"><span style="color:#000000">Metric Conversions and Equivalents</span></span></p>
<p class="initial"> </p>
<p class="initial"><span href="#/acknowledgments" id="acknowledgments" title="Link target outside of Sample"><span style="color:#000000">Acknowledgments </span></span></p>
<p class="initial"> </p>
<p class="initial"><span href="#/index" id="index" title="Link target outside of Sample"><span style="color:#000000">Index</span> </span></p>
<p class="initial"> </p>
<p class="initial"><span href="#/author" id="author" title="Link target outside of Sample"><span style="color:#000000">About Sur La Table</span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?41f365bb